import { cloudinaryLoader } from "@/client/lib/helpers";
import Image, { ImageProps } from "next/image";

export function CloudinaryImage({
  loader,
  alt,
  disableAutoFormat,
  ...props
}: ImageProps & { disableAutoFormat?: boolean }) {
  return (
    <Image
      loader={(props) => cloudinaryLoader(disableAutoFormat ?? false, props)}
      alt={alt ?? ""}
      {...props}
    />
  );
}
